module.exports = __webpack_public_path__ + "static/img/wxcode.19ccfa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/service/images/wxcode.jpg
// module id = rWw+
// module chunks = 15